<template>
    <div>
        <multiselect :class="{'has-error': hasError}" v-model="option" label="name" track-by="fias_id" placeholder="Начните вводить" open-direction="bottom" :multiple="multiple" :options="options" :searchable="true" :loading="isLoading" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300" :show-no-results="false" @search-change="asyncFind" @select="onSelect" @input="onInput">
            <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="multiple && option !== null && option.length" @mousedown.prevent.stop="clearAll([])"></div>
            </template>
        </multiselect>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    name: "Address",
    props: ['value', 'multiple', 'close-event-name', 'has-error'],
    components: {Multiselect},
    data: () => ({
        option: null,
        options_data: [],
        isLoading: false,
    }),
    mounted() {
        this.asyncFind();
        let self = this;
        if (this.closeEventName) {
            this.$bus.$on([this.closeEventName], function () {
                self.clearAll(self.multiple ? [] : null);
            });
        }
    },
    beforeDestroy() {
        if (this.closeEventName) this.$bus.$off([this.closeEventName]);
    },
    watch: {
        option(val) {
            let value = null;
            if (val) {
                if (this.option.length === undefined) { // объект
                    value = this.option.fias_id
                } else { // массив
                    value = this.option.map((v) => {
                        return v.fias_id;
                    })
                }
            }
            this.$emit('input', value);
        },
        value(val) {
            if (val && !this.option) this.asyncFind();
        }
    },
    computed: {
        options() {
            return this.options_data;
        }
    },
    methods: {
        asyncFind(query) {
            let self = this;
            if (!query && this.value && this.value.length && !this.option) {
                this.isLoading = true;
                axios.get('/api/suggestions/addressFindById/' + this.value)
                    .then(r => {
                        self.options_data = [r.data];
                        self.option = r.data;
                        self.isLoading = false;
                    })
            }
            if (!query || query.length <= 2) return;
            this.isLoading = true;
            axios.post('/api/suggestions/address', {query: query})
                .then(r => {
                    self.options_data = r.data;
                    self.isLoading = false;
                })
        },
        onSelect() {
            this.$emit('select');
        },
        onInput() {
            this.$emit('input');
        },
        clearAll(v) {
            this.option = v;
        }
    }
}
</script>

<style scoped>

</style>
